export const makeSelectOptions = (obj: Record<string, string>) => {
  return Object.entries(obj).map(([value, content]) => ({
    value,
    content,
  }));
};
